import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import httpClient, { extractErrorMessage } from '../Services/httpClient';

const ServicePricingPanel = () => {
    const [prices, setPrices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [form, setForm] = useState({ serviceKey: '', priceInLemonCoins: '' });
    const [isSaving, setIsSaving] = useState(false);

    const load = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await httpClient.get('/backoffice/service-prices');
            setPrices(response.data);
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const handleSave = async () => {
        if (!form.serviceKey || form.priceInLemonCoins === '') return;

        setIsSaving(true);
        setError(null);
        setSuccess(null);
        try {
            await httpClient.put(`/backoffice/service-prices/${form.serviceKey}`, Number(form.priceInLemonCoins), {
                headers: { 'Content-Type': 'application/json' }
            });
            setSuccess(`Preço de "${form.serviceKey}" atualizado.`);
            setForm({ serviceKey: '', priceInLemonCoins: '' });
            await load();
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsSaving(false);
        }
    };

    const handleEditRow = (entry) => {
        setForm({ serviceKey: entry.serviceKey, priceInLemonCoins: entry.priceInLemonCoins });
    };

    return (
        <Box sx={{ maxWidth: 720 }}>
            <Paper variant="outlined" sx={{ p: 3, borderRadius: '14px', mb: 3 }}>
                <Typography variant="subtitle1" sx={{ color: '#f77513', fontWeight: 'bold', mb: 2 }}>
                    Definir preço de uma funcionalidade da plataforma
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <TextField
                        label="Chave da funcionalidade (serviceKey)"
                        size="small"
                        value={form.serviceKey}
                        onChange={(e) => setForm((prev) => ({ ...prev, serviceKey: e.target.value }))}
                    />
                    <TextField
                        label="Preço em Lemon Coins"
                        type="number"
                        size="small"
                        value={form.priceInLemonCoins}
                        onChange={(e) => setForm((prev) => ({ ...prev, priceInLemonCoins: e.target.value }))}
                    />
                    <Button
                        variant="contained"
                        disabled={isSaving}
                        style={{ backgroundColor: '#f77513', color: 'white' }}
                        onClick={handleSave}
                    >
                        Salvar
                    </Button>
                </Box>
            </Paper>

            <Typography variant="subtitle1" sx={{ color: '#f77513', fontWeight: 'bold', mb: 1 }}>
                Funcionalidades configuradas
            </Typography>

            {isLoading ? (
                <CircularProgress size={24} style={{ color: '#f77513' }} />
            ) : (
                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '14px' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#fff4ec' }}>
                                <TableCell>Chave</TableCell>
                                <TableCell align="right">Preço</TableCell>
                                <TableCell align="right">Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {prices.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" style={{ color: '#aaa', padding: '24px' }}>
                                        Nenhuma funcionalidade configurada ainda
                                    </TableCell>
                                </TableRow>
                            )}
                            {prices.map((entry) => (
                                <TableRow key={entry.serviceKey}>
                                    <TableCell>{entry.serviceKey}</TableCell>
                                    <TableCell align="right">{entry.priceInLemonCoins} 🍋</TableCell>
                                    <TableCell align="right">
                                        <Button size="small" onClick={() => handleEditRow(entry)} style={{ color: '#f77513' }}>
                                            Editar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default ServicePricingPanel;
